import { formatDate } from "@/shared/lib/date-time";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@devhop/ui";
import type { AttendanceReportTrendItemDTO } from "../../domain/repo/get-attendance-report-trend";

type AttendanceReportTableProps = {
  isLoading: boolean;
  data: AttendanceReportTrendItemDTO[];
};

export function AttendanceReportTable({
  isLoading,
  data,
}: AttendanceReportTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[140px]">ວັນທີ</TableHead>
            <TableHead className="w-[160px]">ຈຳນວນການເຂົ້າຮຽນ</TableHead>
            <TableHead className="w-[180px]">ຈຳນວນນັກຮຽນທີ່ແຕກຕ່າງກັນ</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell
                colSpan={3}
                className="h-24 text-center text-muted-foreground"
              >
                ກຳລັງໂຫລດ...
              </TableCell>
            </TableRow>
          ) : data.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={3}
                className="h-24 text-center text-muted-foreground"
              >
                ບໍ່ພົບຂໍ້ມູນໃນຊ່ວງວັນທີ່ເລືອກ
              </TableCell>
            </TableRow>
          ) : (
            data.map((row) => (
              <TableRow key={row.date}>
                <TableCell className="text-muted-foreground text-sm">
                  {formatDate(row.date)}
                </TableCell>
                <TableCell className="tabular-nums">
                  {row.totalAttendance.toLocaleString()}
                </TableCell>
                <TableCell className="tabular-nums">
                  {row.uniqueStudents.toLocaleString()}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
